<template>
    <Paper>
        <div class="listScan" v-show='listFlag'>
            <span class="page-description">所有扫码率监控</span>
            <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
            <div class="processSearch">
                <el-row>
                    <el-col :span="24">
                        <el-row>
                            <el-col class="sn-search-item">
                                <el-input v-model="searchData['orgCode']" :placeholder="$translate('lang.E3202101270009', { defaultText: '扫码单位编码' })"></el-input>
                            </el-col>
                            <el-col class="sn-search-item">
                                <el-input v-model="searchData['orgName']" :placeholder="$translate('lang.E3202101270010', { defaultText: '扫码单位名称' })"></el-input>
                            </el-col>
                            <el-col class="sn-search-item">
                                <el-date-picker v-model="searchData['time']" type="daterange" align="left" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" unlink-panels
                                    range-separator="-" :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                    :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })" size="mini" :picker-options="pickerOptions"></el-date-picker>
                            </el-col>
                            <el-col class="sn-search-item">
                                <el-select v-model="searchData['entityId']" :placeholder="$translate('lang.E2202203100002', { defaultText: '事业部' })">
                                    <el-option v-for="item in entityList" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <div class="search-margin">
                                <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                                    {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                                </el-button>
                                <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                                    {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                                </el-button>
                            </div>
                        </el-row>
                        <!-- <el-row class="scanCode-second-row">
                            <el-col class="sn-search-item">
                                <el-input v-model="searchData['salesCenCode']" :placeholder="$translate('lang.E2202203100001', { defaultText: '原集团编码' })"></el-input>
                            </el-col>
                        </el-row> -->
                    </el-col>
                </el-row>
            </div>
            <div class="btnList">
                <mExport :url='listExport.exportUrl' :params='listExport.exportParams' :name='listExport.exportName' :exportFlag='listExport.exportFlag' :listData='listData'
                    :titleText='listExport.titleText'>
                </mExport>
            </div>
            <div class="closeStyle">
                <m-table ref="RegistrationTable" :pageTotal="pageTotal" :tableData="listData" :currentPage='currentPage' @pageChange="pageChange" @sizeChange="sizeChange" @handleDetail="handleDetail"
                    :config="tableConfig" @onSelectionChange="onSelectionChange">
                    <div slot="page-module-btn">
                        <el-button type="primary" size="mini" @click="detailExport" :loading="detailLoading">明细导出</el-button>
                    </div>
                </m-table>
            </div>
        </div>
        <m-deatil v-if='!listFlag' ref="deatil" @back="back" :detailSearchParams="detailSearchParams"></m-deatil>
    </Paper>
</template>
<script>
import { scanRateMonitorByPage } from '../../../api/lcbsManagement.js';
import Paper from '@/components/core/paper/Paper';
import mTable from '../../../components/IdentityComponent/Main';
import mDeatil from './component/detail';
import { tableConfig } from './tableConfig.js';
import mExport from '../component/export';
import formatTime from '@/utils/common.js';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import { DICTIONARIES, LOUYU_DIVISION } from './scanCodeControllConst';
import { oneDictDataArr } from '../../../utils/common';
import { exportType } from '../../../api/logManagement';
const TIME_INTERVAL = 24 * 60 * 60 * 1000 * 31; // 时间间隔,不超过31天
const TIME_INTERVAL_EXPORT = 24 * 60 * 60 * 1000 * 31; // 导出时间间隔,不超过31天
const DETAIL_EXPORT_URL = '/api-sn/lbcs/scanRateMonitor/scanRateMonitorDetail/exportAll';// 导出明细接口
export default {
    name: 'scanCodeControll',
    components: { Paper, mTable, mExport, mDeatil },
    data() {
        return {
            tableConfig,
            listFlag: true,
            searchData: {},
            detailSearchParams: {},
            searchLoading: false,
            listData: [],
            pageTotal: 0,
            currentPage: 1,
            listExport: {
                exportUrl: '/api-sn/lbcs/scanRateMonitor/export',
                exportName: this.$translate('lang.E3202101270022', { defaultText: '所有扫码率监控查询列表.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260010', { defaultText: '导出Excel' }),
                exportFlag: 0
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    }
                ]
            },
            entityList: [],
            pageDescription: '',
            selected: [],
            detailLoading: false,
            exportFlag: false,
            lastParams: {}
        };
    },
    methods: {
        initData() {
            this.searchData = {
                orgCode: '',
                orgName: '',
                time: [
                    formatTime.formatDate(formatTime.initStartDate(6)) + ' 00:00:00',
                    formatTime.formatDate(formatTime.initEndDate()) + ' 23:59:59'
                ]
            };
        },
        restSearchChange() {
            this.initData();
            this.listExport.exportFlag = 0;
        },
        handleSearchData() {
            this.lastParams = {};
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            if (!params.time) {
                this.$message.warning(this.$translate('lang.EXC202101270005', { defaultText: '请选择查询日期' }));
                return false;
            }
            if (new Date(params['time'][1]).getTime() - new Date(params['time'][0]).getTime() > TIME_INTERVAL) {
                this.$message.warning(this.$translate('lang.EXC202101270006', { defaultText: '单据日期范围不能超过一个月！' }));
                return false;
            }
            if (!params.entityId) {
                this.$message.warning(this.$translate('lang.E2202203210001', { defaultText: '请先选择事业部' }));
                return false;
            }
            params['startTime'] = params['time'][0];
            params['endTime'] = params['time'][1];
            delete params.time;
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            return params;
        },
        searchChange() {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            const params = this.handleSearchData();
            if (params) {
                this.getData(params);
            }
        },
        getData(params) {
            this.listExport.exportParams = this.handleSearchData();
            this.searchLoading = true;
            scanRateMonitorByPage(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.listExport.exportFlag = 1;
                    this.lastParams = params;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        pageChanges(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
            this.getData(params);
        },
        handleDetail(data) {
            if (!data || LOUYU_DIVISION.indexOf(data.entityId) !== -1) {
                return;
            }
            this.listFlag = false;
            this.detailSearchParams = data;
        },
        back() {
            this.listFlag = true;
        },
        dispoceDict(dictList) {
            if (dictList && +dictList.code === 0) {
                this.entityList = oneDictDataArr(dictList.data[DICTIONARIES]);
            }
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        },
        onSelectionChange(data) {
            this.selected = data;
        },
        detailExport() {
            this.exportFlag = false;
            if (!this.pageTotal) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            }
            let params;
            if (this.selected.length) {
                params = { bcBillDtoList: this.selected };
                params['startTime'] = this.lastParams.startTime.slice(0, 10);
                params['endTime'] = this.lastParams.endTime.slice(0, 10);
            } else {
                params = this.handleSearchData();
                if (new Date(params.endTime).getTime() - new Date(params.startTime).getTime() > TIME_INTERVAL_EXPORT) {
                    this.$message.warning('所有扫码率明细导出不得超过一个月，请修改查询时间范围后导出！');
                    this.exportFlag = true;
                }
            }
            if (this.exportFlag) {
                return;
            }
            this.detailLoading = true;
            const url = DETAIL_EXPORT_URL;
            const type = 'post';
            const name = this.$translate('lang.E2202204060002', { defaultText: '所有扫码率监控明细列表.xls' });
            exportType(params, url, type, name, () => { this.detailLoading = false; });
        }
    },
    async created() {
        const dictList = await dictWithUrl(DICTIONARIES);
        await this.dictData();
        this.dispoceDict(dictList);
    },
    mounted() {
        this.initData();
    }
};
</script>
<style lang="less" src='./index.less'>
</style>
